var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockerXlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 305,
    viewBox: "0 0 239 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500013 93.3967L0.5 241.714C0.5 247.275 3.47888 252.41 8.3063 255.17L88.1893 300.846C92.9101 303.545 98.7002 303.573 103.447 300.919L230.564 229.851C235.464 227.112 238.5 221.936 238.5 216.322L238.5 65.1817C238.5 59.6952 235.6 54.6174 230.874 51.8304L149.954 4.11035C145.052 1.21926 138.959 1.24746 134.084 4.18381L8.00315 80.1189C3.34705 82.9231 0.500014 87.9613 0.500013 93.3967Z",
    fill: "#9035AF",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141 10.1135V166.114M141 166.114L8 243.114M141 166.114L232.5 217.614",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeDasharray: "15 15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9416 298.113V139.31M95.9416 139.31L5 90.1135M95.9416 139.31L235 62.1135",
    stroke: "white",
    strokeDasharray: "15 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerXlIcon);
export default __webpack_public_path__ + "static/media/locker_xl_icon.739b902e6e757cbaf40b8ecbf4c83d34.svg";
export { ForwardRef as ReactComponent };